// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentLoader_root__1XEAq","loader":"ContentLoader_loader__1Dgky","disabled":"ContentLoader_disabled__2R7dm"};